//==========================back-to-top=======================//
$(window).scroll(function() {
if ($(this).scrollTop() > 500) {
$('.top_button').fadeIn(500);
} else {
$('.top_button').fadeOut(500);
}
});	
$('.top_button').click(function(event) {
event.preventDefault();	
$('html, body').animate({scrollTop: 0}, 800);
});

//==================== account toggle ====================//
$(document).ready(function(){
	$(".user-background").click(function(){
	$(".tm_header-dropdown .my-account").slideToggle(800);
	$('.tm_header-dropdown').toggleClass('active'); 
	});
});


//==================== cart toggle ====================//
$(document).ready(function(){
	$(".header__cart-background").click(function(){
	$(".site-header__cart .cart-content.block").slideToggle(800);
	$('.site-header__cart').toggleClass('active'); 
	});
});


//====================== collection tab =======================//
$(document).ready(function() {
    $('.product_tab-block ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });


//=============================== Reviews Slider ==================================//
  var reviewsliders = document.getElementById('Quotes_review_slider');
  var reviewowl = $("#Quotes_review_slider");
  $(reviewowl).each(function (index) {
    $(this).owlCarousel({
      pagination: !0,
      navigation: !1,
      autoPlay: true,
      items : 2, //10 items above 1000px browser width
      itemsDesktop : [1280,2], //5 items between 1000px and 901px
      itemsDesktopSmall : [990,2], // betweem 900px and 601px
      itemsTablet: [600,1], //2 items between 600 and 0
      itemsMobile : [480,1] // itemsMobile disabled - inherit from itemsTablet option
    });

    $(".Quotes_next").click(function(){
      $(reviewowl).trigger('owl.next');
    });
    $(".Quotes_prev").click(function(){
      $(reviewowl).trigger('owl.prev');
    });
  });

//========================blog list slider==========================// 
  var blogowl = $("#blog_slider");
  blogowl.owlCarousel({
    items : 3, //10 items above 1000px browser width
    itemsDesktop : [1269,3], //5 items between 1000px and 901px
    itemsDesktopSmall : [989,3], // betweem 900px and 601px
    itemsTablet: [749,2], //2 items between 600 and 0
    itemsMobile : [479,1]  // itemsMobile disabled - inherit from itemsTablet option
  });
  $(".blog_next").click(function(){
    blogowl.trigger('owl.next');
  });
  $(".blog_prev").click(function(){
    blogowl.trigger('owl.prev');
  });


//======================Featured collection product slider======================//

function addfl(){
	this.$owlItems.removeClass('first last');
	this.$owlItems.eq(this.currentItem).addClass('first');
	this.$owlItems.eq(this.currentItem + (this.owl.visibleItems.length - 1)).addClass('last');
}

$(document).ready(function() {
    var featuredsliders = $("#featured_products_slider");
        featuredsliders.owlCarousel({
            items : 5, //10 items above 1000px browser width
            itemsDesktop : [1269,4], //5 items between 1000px and 901px
            itemsDesktopSmall : [989,3], // betweem 900px and 601px
            itemsTablet: [749,3], //2 items between 600 and 0
            itemsMobile : [479,2] // itemsMobile disabled - inherit from itemsTablet option
        });
        $(".featured_next").click(function(){
            featuredsliders.trigger('owl.next'); 
        });
        $(".featured_prev").click(function(){
            featuredsliders.trigger('owl.prev');
        });
});


//============================ Image Overlay block ===============================//
$( ".collection.overlay-collection_top" ).insertAfter( $( ".hero-top.hero__container" ) );
$(".collection.overlay-collection_top").addClass( "page-width" );  

$( ".collection.overlay-collection_bottom" ).insertAfter( $( ".hero-bottom.hero__container" ) );
$(".collection.overlay-collection_bottom").addClass( "page-width" );  


/*====================== overlay collection product slider======================*/
$(document).ready(function() {
    var overlaycollectionsliders = $("#overlay-collection_top_products_slider");
        overlaycollectionsliders.owlCarousel({
            items : 1 , //10 items above 1000px browser width
            itemsDesktop : [1280,1], //5 items between 1000px and 901px
            itemsDesktopSmall : [990,1], // betweem 900px and 601px
            itemsTablet: [749,1], //2 items between 600 and 0
            itemsMobile : [479,1], // itemsMobile disabled - inherit from itemsTablet option
          	autoPlay: true
        });
        $(".overlay-collection_top_next").click(function(){
            overlaycollectionsliders.trigger('owl.next'); 
        });
        $(".overlay-collection_top_prev").click(function(){
            overlaycollectionsliders.trigger('owl.prev');
        });
});


$(document).ready(function() {
    var overlaycollectionbottomsliders = $("#overlay-collection_bottom_products_slider");
        overlaycollectionbottomsliders.owlCarousel({
            items : 1 , //10 items above 1000px browser width
            itemsDesktop : [1280,1], //5 items between 1000px and 901px
            itemsDesktopSmall : [990,1], // betweem 900px and 601px
            itemsTablet: [749,1], //2 items between 600 and 0
            itemsMobile : [479,1], // itemsMobile disabled - inherit from itemsTablet option
          	autoPlay: true
        });
        $(".overlay-collection_bottom_next").click(function(){
            overlaycollectionbottomsliders.trigger('owl.next'); 
        });
        $(".overlay-collection_bottom_prev").click(function(){
            overlaycollectionbottomsliders.trigger('owl.prev');
        });
});


/*=====================  More site navigation =======================*/
function more() {
  if ($(window).width() > 1600){
    var max_elem = 7;
    var items = $('#SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.hiden_menu').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else if ($(window).width() > 1269){
    var max_elem = 5;
    var items = $('#SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.hiden_menu').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
//   else if ($(window).width() > 989){
//     var max_elem = 4;
//     var items = $('#SiteNav > li');
//     var surplus = items.slice(max_elem, items.length);
//     surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
//     $('.hiden_menu').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
//   }
  else {
    var max_elem = 4;
    var items = $('#SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.hiden_menu').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
}
$(document).ready(function() {
    more()
});


// ================================ Product tab slider ==================================//

$(document).ready(function() {
    var overlaycollectionbottomsliders = $("#best-seller_products_slider");
        overlaycollectionbottomsliders.owlCarousel({
            items : 5, //10 items above 1000px browser width
            itemsDesktop : [1269,4], //5 items between 1000px and 901px
            itemsDesktopSmall : [989,3], // betweem 900px and 601px
            itemsTablet: [749,3], //2 items between 600 and 0
            itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
        });
        $(".best-seller_next").click(function(){
            overlaycollectionbottomsliders.trigger('owl.next'); 
        });
        $(".best-seller_prev").click(function(){
            overlaycollectionbottomsliders.trigger('owl.prev');
        });
});

// ================================ Related Product slider ==================================//

$(document).ready(function() {
  	var relatedowl = $("#related_products_slider");
    relatedowl.owlCarousel({
        items : 5 , //10 items above 1000px browser width
        itemsDesktop : [1269,4], //5 items between 1000px and 901px
        itemsDesktopSmall : [989,3], // betweem 900px and 601px
        itemsTablet: [749,3], //2 items between 600 and 0
        itemsMobile : [479,2]  // itemsMobile disabled - inherit from itemsTablet option
    });
    $(".related_next").click(function(){
    	relatedowl.trigger('owl.next');
    });
    $(".related_prev").click(function(){
    	relatedowl.trigger('owl.prev');
    });
});

//========================brand list slider==========================//
$(document).ready(function() {
  var brandsowl = $("#brands_list_slider");
  brandsowl.owlCarousel({
    items : 6, //10 items above 1000px browser width
    itemsDesktop : [1269,5], //4 items between 1269px and 990px
    itemsDesktopSmall : [989,4], //4 items betweem 989px and 750px
    itemsTablet: [749,3], //2 items between 749 and 480
    itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
  });
  $(".brands_next").click(function(){
    brandsowl.trigger('owl.next');
  });
  $(".brands_prev").click(function(){
    brandsowl.trigger('owl.prev');
  });
});

/* ============================= service insert after ====================*/
$( ".service-block" ).insertAfter( $( ".custom__item" ) );

//======================== Sticky header ======================//
function StickyHeader(){	
	"use strict";	
	var num = 190; //number of pixels before modifying styles
	
		jQuery(window).bind('scroll', function () {
			if (jQuery(window).scrollTop() > num) {
				jQuery('.header-fix').addClass('sticky-menu');
				jQuery('.site-header-fix').addClass('header-style');
				jQuery('.category-box').addClass('home-category-fix');
				jQuery('.home-category').addClass('home-category-fix1');
				
			} else {
				jQuery('.header-fix').removeClass('sticky-menu');		
				jQuery('.site-header-fix').removeClass('header-style');
				jQuery('.category-box').removeClass('home-category-fix');
			}
		})
}
jQuery(document).ready(function() { "use strict";   StickyHeader()});
jQuery(window).resize(function() {  "use strict";   StickyHeader()});

//====================== collection tab =======================//
$(document).ready(function() {
    $('.product-single__description ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });


/*==================sidebar toggle====================*/
function mobileToggleColumn1(){
  if ($(window).width() < 990){
    $(".side-bar h3.box-heading").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar h3.box-heading").addClass('toggle');
    $(".side-box .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').parent().find('.box-content').slideToggle('slow');
    });    
  }
  else{
    $(".side-bar h3.box-heading").removeClass('toggle');
    $(".side-bar h3.box-heading").removeClass('active');
    $(".side-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn1);


/*==================footer toggle====================*/
function mobileToggleColumn(){
  if ($(window).width() < 990){
    $(".site-footer .footer-box  h5").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".site-footer .footer-box h5").addClass('toggle');
    $(".footer-box .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').parent().find('.footer-content').slideToggle('slow');
    });    
  }
  else{
    $(".site-footer .footer-box  h5").removeClass('toggle');
    $(".site-footer .footer-box h5").removeClass('active');
    $(".footer-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn);

//======================mobile menu toogle======================//
$(document).ready(function(){

 
  $("#MobileNav .mobile-nav__dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile_togglecolumn').click(function () {
            $(this).parent().toggleClass('active');
        });
  
   $("#MobileNav .mobile-nav__grand_dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile-nav__grand__item .mobile_togglecolumn').click(function () {
            $(this).parent().toggleClass('active');
        });
 		
});

/*================== sidebar category-box ===================*/
function mobileToggleMenu10(){
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');    
    });    
}
$(document).ready(mobileToggleMenu10);

function mobileToggleMenu11(){
    $(".side-bar #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle'); 
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.grand-child-has-dropdown').slideToggle('slow'); 
    });    
}
$(document).ready(mobileToggleMenu11);


//------------------------------ Responsive left column------------------
function responsivecolumn()
{
	if ($(document).width() <= 990)
	{
		$('.main-content .page-width.contents .side-bar').insertAfter('.main-content .page-width.contents .main-container');
	}
}
$(document).ready(function(){responsivecolumn(); });
$(window).resize(function(){responsivecolumn(); });
 